module.exports = __webpack_public_path__ + "img/mon_256.2ade9872.png";